module.exports = __webpack_public_path__ + "static/media/ZillaSlab-Medium.c52635a6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ZillaSlab-Medium.ttf
// module id = 3489
// module chunks = 51